<template>
  <v-sheet class="transparent" max-width="100%">
    <div class="my-1 d-flex text-h6">
      {{ data.category_name }}
      <v-checkbox
        v-show="!search"
        v-model="checkboxes[data.id_tipo]"
        color="primary"
        class="mx-auto my-auto pl-2"
        :disabled="!canInsertOrDeleteCasinoGame"
        @click="categoryClicked(data.id_tipo, categoryIndex)"
      >
      </v-checkbox>
      <v-divider class="ml-2 mt-4"></v-divider>
    </div>
    <v-slide-group
      v-model="model"
      class="mb-8"
      :show-arrows="!$vuetify.breakpoint.smAndDown"
    >
      <template slot="prev">
        <v-icon>
          mdi-chevron-left
        </v-icon>
      </template>

      <template slot="next">
        <v-icon>
          mdi-chevron-right
        </v-icon>
      </template>

      <v-row justify="center" align="center" class="my-1">
        <v-slide-item
          v-for="(game, index) in data.items"
          :key="index"
          v-slot:default="{ active, toggle }"
        >
          <v-card
            class="mx-1 transparent"
            :width="150"
            @click="toggle"
            elevation="0"
            :style="index === 0 ? 'margin-left: 0.7rem !important;' : ''"
          >
            <v-hover v-slot="{ hover }">
              <v-img
                :key="
                  `${gameAPI}/game_pic/rec/325/${
                    game.id_game.split('-')[1]
                  }.png`
                "
                :src="
                  `${gameAPI}/game_pic/rec/325/${
                    game.id_game.split('-')[1]
                  }.png`
                "
                :lazy-src="
                  `${gameAPI}/game_pic/rec/188/${
                    game.id_game.split('-')[1]
                  }.png`
                "
                :max-width="150"
                max-height="234"
                class="grey lighten-2 mx-auto"
                :class="index + 1 === data.items.length ? 'mr-2' : ''"
                style="border-radius: 10px;"
                @click="canInsertOrDeleteCasinoGame && gameClicked(game)"
              >
                <v-overlay
                  v-if="hover && canInsertOrDeleteCasinoGame"
                  absolute
                  @click="canInsertOrDeleteCasinoGame && gameClicked(game)"
                ></v-overlay>

                <v-checkbox
                  v-model="getCheckboxes[game.id]"
                  :disabled="!canInsertOrDeleteCasinoGame"
                  color="primary"
                  class="my-auto pt-1 pl-1"
                  dark
                  hide-details
                >
                </v-checkbox>
              </v-img>
            </v-hover>
          </v-card>
        </v-slide-item>
      </v-row>
    </v-slide-group>
  </v-sheet>
</template>
<script>
export default {
  props: ["data", "categoryIndex", "checkboxes", "search"],
  data: () => ({
    gameAPI: "https://api.prerelease-env.biz",
    model: 0,
  }),
  methods: {
    gameClicked(game) {
      this.checkboxes[game.id] = !this.checkboxes[game.id];
      this.$emit("gameClicked", game, this.checkboxes[game.id]);
    },
    categoryClicked(id_tipo, categoryIndex) {
      this.$emit("categoryClicked", id_tipo, categoryIndex);
    },
  },
  computed: {
    getCheckboxes() {
      return this.checkboxes;
    },
    canInsertOrDeleteCasinoGame() {
      return this.$permission("69");
    },
  },
};
</script>
<style>
.v-slide-group__next--disabled, .v-slide-group__prev--disabled {
  display: none;
}
</style>